//@flow
import { SET_COMPANY_GROUP_LICENCES } from "../../global/actions/actionNames";
import { LicenceCompany, LicenceActionType } from "../types/licenceTypes";

export type AccountLicenceStateType = LicenceCompany;

const initialState: AccountLicenceStateType = {
  id: "",
  uuid: "",
  name: "",
  licences: null,
  children: null
};

const licenceReducers = (
  state: AccountLicenceStateType = initialState,
  actions: LicenceActionType
) => {
  switch (actions.type) {
    case SET_COMPANY_GROUP_LICENCES:
      return {
        ...state,
        id: actions.company.id,
        uuid: actions.company.uuid,
        name: actions.company.name,
        companyType: actions.company.companyType,
        licences: actions.company.licences,
        children: actions.company.children
      };
      break;

    default:
      return state;
  }
};

export default licenceReducers;
